/**
 * chartColorHelper.js
 * Utility to generate harmonious and distinct colors for dynamic charts.
 */

const BASE_PALETTE = [
  // --- Modern Primary (Tailwind Style) ---
  "#6366F1", "#8B5CF6", "#EC4899", "#F43F5E", "#EF4444",
  "#F97316", "#F59E0B", "#EAB308", "#84CC16", "#22C55E",
  "#10B981", "#14B8A6", "#06B6D4", "#0EA5E9", "#3B82F6",

  // --- Earthy & Sophisticated (New Trends) ---
  "#436850", "#12372A", "#ADBC9F", "#789461", "#606C38",
  "#283618", "#DDA15E", "#BC6C25", "#5F6F52", "#A9B388",

  // --- Muted & Professional Neutrals ---
  "#64748B", "#475569", "#334155", "#94A3B8", "#1E293B",

  // --- Deep Jewel Tones ---
  "#581C87", "#701A75", "#4C1D95", "#1E40AF", "#164E63",
  "#065F46", "#3F6212", "#854D0E", "#991B1B", "#7F1D1D"
];

/**
 * Generates an array of colors of a specified length.
 * Now supports larger banks and ensures professional saturation/lightness.
 * 
 * @param {number} count Number of colors needed
 * @returns {string[]} Array of color strings
 */
export const generateChartColors = (count) => {
  if (count <= 0) return [];

  // Jika butuh sedikit, ambil dari palet terbaik yang sudah dikurasi
  if (count <= BASE_PALETTE.length) {
    return BASE_PALETTE.slice(0, count);
  }

  const result = [...BASE_PALETTE];

  // Generate sisanya hingga mencapai 500+ jika perlu
  for (let i = BASE_PALETTE.length; i < count; i++) {
    /**
     * Menggunakan Golden Ratio agar hue tersebar merata.
     * Mengatur Saturation (65-75%) dan Lightness (55-65%) 
     * agar warna tetap terlihat modern (tidak terlalu neon/mati).
     */
    const hue = (i * 137.508) % 360;

    // Variasi sedikit pada saturation dan lightness agar lebih dinamis
    const s = 65 + (i % 10); // Variasi saturasi 65% - 75%
    const l = 55 + (i % 5);  // Variasi kecerahan 55% - 60%

    result.push(`hsl(${hue}, ${s}%, ${l}%)`);
  }

  return result;
};